module.exports = __webpack_public_path__ + "img/cellarmaster-demo.47320bbf.gif";